if (!customElements.get("testimonials-slider")) {
  class testimonialsSlider extends HTMLElement {
    connectedCallback() {
      if (this.glide) return;

      if (typeof window.Glide !== "function") {
        this._retry = setTimeout(() => this.connectedCallback(), 80);
        return;
      }

      const slideCount = Number(this.dataset.slideCount) || 1;

      if (slideCount < 3) return;

      const startAt = Math.min(
        Math.max(Number(this.dataset.startAt) || 0, 0),
        slideCount - 1,
      );

      const styles = getComputedStyle(this);

      const gap =
        parseFloat(styles.getPropertyValue("--testimonial-gap")) || 24;
      const gapMobile =
        parseFloat(styles.getPropertyValue("--testimonial-mobile-gap")) || 24;

      this.glide = new window.Glide(this, {
        type: "carousel",
        startAt: 0,
        perView: 2,
        focusAt: "center",
        gap: gap,
        peek: { before: 80, after: 80 },
        keyboard: true,
        animationDuration: 500,
        breakpoints: {
          989: {
            gap: gapMobile,
          },
          749: {
            gap: gapMobile,
            perView: 1,
            focusAt: 0,
            peek: { before: 0, after: 40 },
          },
        },
      });

      this.glide.on(["mount.after", "run.after"], () => {
        const currentIndex =
          ((this.glide.index % slideCount) + slideCount) % slideCount;
        const counter = this.querySelector("[data-story-counter]");
        if (counter) counter.textContent = currentIndex + 1;
      });

      this.glide.mount();

      this._onBlockSelect = (event) => {
        const slide = event.target.closest("[data-story-index]");
        if (!slide || !this.contains(slide)) return;
        this.glide.go(`=${slide.dataset.storyIndex}`);
      };

      this._onSectionLoad = () => {
        if (this.glide) {
          this.glide.destroy();
          this.glide = null;
        }
        this.connectedCallback();
      };

      this.addEventListener("shopify:block:select", this._onBlockSelect);
      document.addEventListener("shopify:section:load", this._onSectionLoad);
    }

    disconnectedCallback() {
      clearTimeout(this._retry);
      this.removeEventListener("shopify:block:select", this._onBlockSelect);
      document.removeEventListener("shopify:section:load", this._onSectionLoad);
      if (this.glide) this.glide.destroy();
      this.glide = null;
    }
  }

  customElements.define("testimonials-slider", testimonialsSlider);
}

this._onSectionLoad = (event) => {
  if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;
  if (this.glide) {
    this.glide.destroy();
    this.glide = null;
  }
  this.connectedCallback();
};
